import { render, staticRenderFns } from "./ProgramAwardConfigurationTab.vue?vue&type=template&id=abdc7e9e&scoped=true&"
import script from "./ProgramAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProgramAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProgramAwardConfigurationTab.vue?vue&type=style&index=0&id=abdc7e9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdc7e9e",
  null
  
)

export default component.exports